import React from "react";
import {
  Box,
  Heading,
  Text,
  Button,
  VStack,
  useColorModeValue,
  HStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { PublicNavbar } from "./layout/PublicNavbar";
import { Footer } from "./layout/Footer";
import { useTranslation } from "react-i18next";

export const Soon = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const { t } = useTranslation();

  return (
    <Box>
      <PublicNavbar />
      <Box bg={bgColor} pt={80} pb={40}>
        <VStack spacing={8} textAlign="center">
          <Heading size="4xl">{t("common.soon.title")}</Heading>
          <Heading size="xl">{t("common.soon.heading")}</Heading>
          <Text fontSize="lg">{t("common.soon.description")}</Text>
          <HStack>
            <Button colorScheme="blue" size="lg" onClick={() => navigate("/")}>
              {t("common.soon.button")}
            </Button>
            <Button
              colorScheme="brand"
              size="lg"
              onClick={() =>
                window.open("https://blog.araria.com.br/", "_blank")
              }
            >
              {t("common.soon.blog")}
            </Button>
          </HStack>
        </VStack>
      </Box>
      <Footer />
    </Box>
  );
};
